
AddSiteToGroupController.$inject = ['$scope', '$mdDialog', '$translate', 'addableSites', 'StrategiesFactory'];
export function AddSiteToGroupController($scope, $mdDialog, $translate, addableSites, StrategiesFactory) {

  $scope.ok = ok;
  $scope.cancel = cancel;

  init();

  function ok() {
    $mdDialog.hide($scope.addedSiteIds);
  }

  function cancel() {
    $mdDialog.cancel();
  }

  function init() {
    $scope.addedSiteIds = [];
    $scope.addableSites = addableSites.map((site) => {
      const platform = StrategiesFactory.getStrategyFromType(site.type).getTypeString();
      return {
        id: site.id,
        label: site.name,
        platform,
        iconClass: `alc-site-icon-inline bg-img-${site.type_name}`
      }
    });

    $scope.sitesLabel = $translate.instant('groups/edition/select-site');
  }
}
